/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_NotesInputs */



/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Transcript_Export_Field_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_notes = /** @type {((inputs?: Transcript_Export_Field_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notes")
	return /** @type {LocalizedString} */ ("Notes")
});